"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[77060],{

/***/ 27049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config_provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59844);



var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





var Divider = function Divider(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_config_provider__WEBPACK_IMPORTED_MODULE_2__/* .ConfigConsumer */ .C, null, function (_ref) {
    var _classNames;

    var getPrefixCls = _ref.getPrefixCls,
        direction = _ref.direction;

    var customizePrefixCls = props.prefixCls,
        _props$type = props.type,
        type = _props$type === void 0 ? 'horizontal' : _props$type,
        _props$orientation = props.orientation,
        orientation = _props$orientation === void 0 ? 'center' : _props$orientation,
        className = props.className,
        children = props.children,
        dashed = props.dashed,
        plain = props.plain,
        restProps = __rest(props, ["prefixCls", "type", "orientation", "className", "children", "dashed", "plain"]);

    var prefixCls = getPrefixCls('divider', customizePrefixCls);
    var orientationPrefix = orientation.length > 0 ? "-".concat(orientation) : orientation;
    var hasChildren = !!children;
    var classString = classnames__WEBPACK_IMPORTED_MODULE_1___default()(prefixCls, "".concat(prefixCls, "-").concat(type), (_classNames = {}, (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-with-text"), hasChildren), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-with-text").concat(orientationPrefix), hasChildren), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-dashed"), !!dashed), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-plain"), !!plain), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className);
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
      className: classString
    }, restProps, {
      role: "separator"
    }), children && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      className: "".concat(prefixCls, "-inner-text")
    }, children));
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Divider);

/***/ }),

/***/ 71378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SwitchPortfolio; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/popover/index.js + 1 modules
var popover = __webpack_require__(10808);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 1 modules
var tooltip = __webpack_require__(56266);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/lib/stores/multiPorto.ts
var multiPorto = __webpack_require__(34385);
// EXTERNAL MODULE: ./src/features/multi-porto/hooks/useSubAccounts.ts
var useSubAccounts = __webpack_require__(65361);
// EXTERNAL MODULE: ./src/features/multi-porto/hooks/useSwitchAction.ts
var useSwitchAction = __webpack_require__(74981);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSecuritiesCredentialStore.ts + 1 modules
var useSecuritiesCredentialStore = __webpack_require__(71158);
// EXTERNAL MODULE: ./src/features/multi-porto/stores/modal.store.ts
var modal_store = __webpack_require__(3683);
// EXTERNAL MODULE: ./src/global/Securities/types/api/multiPorto.ts
var api_multiPorto = __webpack_require__(96909);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/multi-porto/components/SwitchContent/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  line-height: 19px;\n  color: #333333;\n\n  .label {\n    display: inline-block;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 120px;\n  }\n\n  .pending-porto {\n    flex: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  max-width: 170px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 0;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  border: 1px solid #EDEDED;\n  min-width: 260px;\n  flex-direction: column;\n  margin-top: -8px;\n  box-shadow: 10px 10px 30px 0px #00000066;\n\n  .divider {\n    margin: 0;\n    height: 4px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 8px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px;\n  width: 100%;\n  border-radius: 6px;\n  border: 1px solid #ffffff;\n  color: #333333;\n\n  span {\n    font-size: 14px;\n    line-height: 19px;\n  }\n\n  span.main-porto {\n    color: #858585;\n    display: flex;\n    align-items: center;\n    padding-left: 4px;\n  }\n\n  span.pending-porto {\n    font-size: 11px;\n    line-height: 14px;\n    padding: 3px 6px;\n    margin-left: 8px;\n    background: #F7F7F7;\n    color: #858585;\n    cursor: pointer;\n  }\n\n  &:hover {\n    background: #F7F7F7;\n    border: 1px solid #F7F7F7;\n\n    .active-icon {\n      opacity: 0;\n    }\n\n    .rename-icon.active {\n      opacity: 1;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  position: relative;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  transition: opacity 0.3s ease;\n\n  &.active-icon {\n    opacity: 1;\n  }\n\n  &.rename-icon {\n    opacity: 1;\n  }\n\n  &.rename-icon.active {\n    opacity: 0;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 8px;\n  justify-content: flex-start;\n  cursor: pointer;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 2px 6px;\n  cursor: pointer;\n  border-radius: 4px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 13px;\n  line-height: 18px;\n  color: #333333;\n  text-align: center;\n  margin: 0;\n  white-space: nowrap;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #f1f1f1;\n  width: 100%;\n\n  height: ",
        "px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var MenuText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97b74e34-0"
})(_templateObject());
var ItemTextName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-97b74e34-1"
})(_templateObject1(), function(param) {
    var isMain = param.isMain;
    return isMain && "\n    max-width: 130px;\n  ";
});
var ButtonSettingsContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97b74e34-2"
})(_templateObject2(), function(param) {
    var width = param.width;
    return width && "\n    min-width: ".concat(width, "px !important;\n  ");
});
var SectionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97b74e34-3"
})(_templateObject3());
var ButtonSwitchItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97b74e34-4"
})(_templateObject4());
var ImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97b74e34-5"
})(_templateObject5());
var ButtonRename = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97b74e34-6"
})(_templateObject6());
var ButtonSwitchItemAction = (0,styled_components_browser_esm/* default */.ZP)(ButtonSwitchItem).withConfig({
    componentId: "sc-97b74e34-7"
})(_templateObject7());
var TooltipContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97b74e34-8"
})(_templateObject8());
var TooltipText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-97b74e34-9"
})(_templateObject9());
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97b74e34-10"
})(_templateObject10(), function(props) {
    return props.height;
});

;// CONCATENATED MODULE: ./src/features/multi-porto/components/SwitchContent/index.tsx














function MenuSwitchContent(param) {
    var _hideTransfer = param.hideTransfer, hideTransfer = _hideTransfer === void 0 ? false : _hideTransfer, _width = param.width, width = _width === void 0 ? 0 : _width, source = param.source, onClick = param.onClick, _onClose = param.onClose, onClose = _onClose === void 0 ? function() {} : _onClose, onSuccessSwitch = param.onSuccessSwitch;
    var ref = (0,react.useState)({}), isEllipsis = ref[0], setIsEllipsis = ref[1];
    var activeAccount = (0,multiPorto/* default */.Z)(function(s) {
        return s.activeAccount;
    });
    var ref1 = (0,useSubAccounts/* default */.Z)(), subAccounts = ref1.subAccounts, approvedSubAccounts = ref1.approvedSubAccounts;
    var subAccountsLength = approvedSubAccounts.length;
    var setModal = (0,modal_store/* default */.Z)(function(s) {
        return s.openModal;
    });
    var ref2 = (0,useSwitchAction/* default */.Z)(), onOpenTransferCash = ref2.onOpenTransferCash, onOpenTransferStock = ref2.onOpenTransferStock, onCreatePortfolio = ref2.onCreatePortfolio;
    var setRenameForm = (0,multiPorto/* default */.Z)(function(s) {
        return s.setRenamePortfolioForm;
    });
    var loadSwitchLoginReal = (0,useSecuritiesCredentialStore/* default */.Z)(function(s) {
        return s.loadSwitchLoginReal;
    });
    var handleSelect = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(accountNumber) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return loadSwitchLoginReal(accountNumber).then(function() {
                            onClick();
                            onSuccessSwitch(accountNumber);
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSelect(accountNumber) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickRename = function(accountNumber, portfolioName) {
        onClick();
        onClose();
        setModal(modal_store/* ModalNames.PORTFOLIO_RENAME */.s.PORTFOLIO_RENAME);
        setRenameForm({
            target_account_number: accountNumber,
            new_portfolio_name: portfolioName
        });
    };
    var handleOpenTransferCash = function() {
        onClick();
        onOpenTransferCash();
    };
    var handleOpenTransferStock = function() {
        onClick();
        onOpenTransferStock();
    };
    var handleCreatePortfolio = function() {
        onClick();
        onClose();
        onCreatePortfolio();
    };
    var checkIfEllipsis = function(id) {
        var element = document.getElementById(id);
        if (element) {
            return element.offsetWidth < element.scrollWidth;
        }
        return false;
    };
    (0,react.useEffect)(function() {
        setTimeout(function() {
            var ellipsisStatus = {};
            subAccounts.forEach(function(portfolio) {
                var accountNumber = portfolio.account_number;
                var elementId = "portfolio-menu-".concat(accountNumber);
                ellipsisStatus[accountNumber] = checkIfEllipsis(elementId);
            });
            setIsEllipsis(ellipsisStatus);
        }, 500);
    }, [
        subAccounts.length
    ]);
    if (subAccounts.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonSettingsContent, {
        width: width,
        onClick: function(e) {
            return e.stopPropagation();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionContainer, {
                children: [
                    subAccounts.map(function(portfolio) {
                        var status = portfolio.account_status;
                        var accountNumber = portfolio.account_number;
                        var portfolioInfo = portfolio.portfolio_info;
                        var portfolioName = portfolioInfo.portfolio_name;
                        var isApproved = status === api_multiPorto/* SubAccountStatus.APPROVED */.go.APPROVED;
                        var isPending = status === api_multiPorto/* SubAccountStatus.PENDING */.go.PENDING;
                        var isActive = accountNumber === activeAccount;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonSwitchItem, {
                            onClick: function() {
                                if (!isApproved) return;
                                if (!isActive) {
                                    handleSelect(accountNumber);
                                }
                            },
                            style: {
                                cursor: isApproved ? "pointer" : "default"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuText, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                            destroyTooltipOnHide: true,
                                            title: isEllipsis[accountNumber] ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText, {
                                                children: portfolio.portfolio_info.portfolio_name
                                            }) : "",
                                            placement: "bottom",
                                            arrowPointAtCenter: false,
                                            color: "#ffffff",
                                            getTooltipContainer: function(trigger) {
                                                return trigger.parentElement;
                                            },
                                            overlayInnerStyle: {
                                                marginTop: "-4px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTextName, {
                                                isMain: portfolio.is_main_account,
                                                id: "portfolio-menu-".concat(accountNumber),
                                                children: portfolio.portfolio_info.portfolio_name
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                            condition: portfolio.is_main_account,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "main-porto",
                                                children: " • Main"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                    condition: isPending,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                        destroyTooltipOnHide: true,
                                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText, {
                                            children: "Portofolio baru masih dalam proses verifikasi"
                                        }),
                                        placement: "bottomRight",
                                        arrowPointAtCenter: false,
                                        color: "#ffffff",
                                        getTooltipContainer: function(trigger) {
                                            return trigger.parentElement;
                                        },
                                        overlayStyle: {
                                            minWidth: source === "portfolio" ? "275px" : "295px"
                                        },
                                        overlayInnerStyle: {
                                            marginTop: "-4px",
                                            marginRight: source === "portfolio" ? "-20px" : "0"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "pending-porto",
                                            children: "In Verification"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                    condition: isApproved,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageContainer, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                                condition: isActive,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonRename, {
                                                    className: "active-icon",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        src: "/icon/check/filled.svg",
                                                        alt: "",
                                                        width: 18,
                                                        height: 18
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                                condition: isApproved,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                                    destroyTooltipOnHide: true,
                                                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipContent, {
                                                        onClick: function(e) {
                                                            return e.stopPropagation();
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText, {
                                                            children: "Rename Portfolio"
                                                        })
                                                    }),
                                                    placement: "bottom",
                                                    arrowPointAtCenter: false,
                                                    color: "#ffffff",
                                                    getTooltipContainer: function(trigger) {
                                                        return trigger.parentElement;
                                                    },
                                                    overlayInnerStyle: {
                                                        marginTop: "-4px"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonRename, {
                                                        className: "rename-icon ".concat(isActive ? "active" : ""),
                                                        onClick: function(e) {
                                                            e.stopPropagation();
                                                            handleClickRename(accountNumber, portfolioName);
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            src: "/icon/multi-porto/rename-porto.svg",
                                                            alt: "",
                                                            width: 16,
                                                            height: 16
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, accountNumber + portfolioName);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {
                        height: 1,
                        style: {
                            margin: "8px 0"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonSwitchItemAction, {
                        onClick: handleCreatePortfolio,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/icon/plus/secondary.svg",
                                alt: "",
                                width: 16,
                                height: 16
                            }),
                            "Create New Portfolio"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                condition: !hideTransfer && subAccountsLength > 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {
                        height: 4
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonSwitchItemAction, {
                                onClick: handleOpenTransferCash,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/icon/multi-porto/transfer-cash.svg",
                                        alt: "",
                                        width: 16,
                                        height: 16
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Transfer Cash"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonSwitchItemAction, {
                                onClick: handleOpenTransferStock,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/icon/multi-porto/transfer-stock.svg",
                                        alt: "",
                                        width: 16,
                                        height: 16
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Transfer Stock"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/hooks/useBroadcastChannel.ts
var useBroadcastChannel = __webpack_require__(21489);
;// CONCATENATED MODULE: ./src/features/multi-porto/components/SwitchPopover/popover.styled.ts

function popover_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    popover_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function popover_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 6px;\n  padding: 5px 8px;\n  cursor: pointer;\n  user-select: none;\n  background: #ebf8f3;\n  border: 1px solid #ebf8f3;\n\n  img {\n    transform: rotate(0deg);\n    transition: transform 0.3s ease;\n  }\n\n  img.open {\n    transform: rotate(180deg);\n  }\n\n  border-radius: ",
        "px;\n"
    ]);
    popover_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function popover_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n\n  span {\n    font-size: 14px;\n    line-height: 19px;\n    color: #00a86b;\n    display: inline-block;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 190px;\n  }\n"
    ]);
    popover_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Flex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1e8a8f7-0"
})(popover_styled_templateObject());
var SwitchButton = (0,styled_components_browser_esm/* default */.ZP)(Flex).withConfig({
    componentId: "sc-b1e8a8f7-1"
})(popover_styled_templateObject1(), function(param) {
    var radius = param.radius;
    return radius;
});
var popover_styled_MenuText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1e8a8f7-2"
})(popover_styled_templateObject2());

;// CONCATENATED MODULE: ./src/features/multi-porto/components/SwitchPopover/index.tsx








function SwitchPortfolio(param) {
    var placement = param.placement, _hideTransfer = param.hideTransfer, hideTransfer = _hideTransfer === void 0 ? false : _hideTransfer, _width = param.width, width = _width === void 0 ? 0 : _width, _radius = param.radius, radius = _radius === void 0 ? 4 : _radius, _source = param.source, source = _source === void 0 ? "" : _source, _onClick = param.onClick, onClick = _onClick === void 0 ? function() {} : _onClick;
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var postMessage = (0,useBroadcastChannel/* default */.Z)("multi-portfolio").postMessage;
    var ref1 = (0,useSubAccounts/* default */.Z)(), subAccounts = ref1.subAccounts, activeAccountName = ref1.activeAccountName;
    var handleClickMenu = function() {
        setVisible(false);
    };
    if (subAccounts.length <= 1) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* default */.Z, {
        destroyTooltipOnHide: true,
        visible: visible,
        onVisibleChange: function() {
            return setVisible(!visible);
        },
        motion: {
            motionName: "fade"
        },
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuSwitchContent, {
            hideTransfer: hideTransfer,
            onClick: handleClickMenu,
            onClose: onClick,
            onSuccessSwitch: function(acountNumber) {
                postMessage({
                    type: "refetch-portfolio",
                    message: acountNumber
                });
            },
            width: width,
            source: source
        }),
        trigger: "click",
        placement: placement,
        getPopupContainer: function(trigger) {
            return trigger.parentElement;
        },
        zIndex: 10,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwitchButton, {
            radius: radius,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/multi-porto/portfolio.svg",
                    alt: "",
                    width: 16,
                    height: 16
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_styled_MenuText, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: activeAccountName || "Switch Portfolio"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/chevron/down-primary.svg",
                    alt: "",
                    className: visible ? "open" : "",
                    width: 16,
                    height: 16
                })
            ]
        })
    });
};


/***/ }),

/***/ 65361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSubAccounts; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lib_stores_multiPorto__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34385);
/* harmony import */ var global_Securities_types_api_multiPorto__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96909);



function useSubAccounts() {
    var ref, ref1;
    var subAccountsData = (0,lib_stores_multiPorto__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(s) {
        return s.subAccountsData;
    });
    var activeAccount = (0,lib_stores_multiPorto__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(s) {
        return s.activeAccount;
    });
    var getSubAccounts = (0,lib_stores_multiPorto__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(s) {
        return s.getSubAccounts;
    });
    var subAccounts = (subAccountsData === null || subAccountsData === void 0 ? void 0 : (ref = subAccountsData.data) === null || ref === void 0 ? void 0 : ref.sub_accounts) || [];
    var canCreatePortfolio = subAccountsData === null || subAccountsData === void 0 ? void 0 : (ref1 = subAccountsData.data) === null || ref1 === void 0 ? void 0 : ref1.can_create_new_sub_account;
    var subAccountError = subAccountsData === null || subAccountsData === void 0 ? void 0 : subAccountsData.error;
    var approvedSubAccounts = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return subAccounts.filter(function(sub) {
            return sub.account_status === global_Securities_types_api_multiPorto__WEBPACK_IMPORTED_MODULE_2__/* .SubAccountStatus.APPROVED */ .go.APPROVED;
        });
    }, [
        JSON.stringify(subAccounts)
    ]);
    var activePortfolio = subAccounts.find(function(sub) {
        return sub.account_number === activeAccount;
    });
    var activeAccountName = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (subAccounts.length > 1 && activePortfolio) {
            return activePortfolio.portfolio_info.portfolio_name || "";
        }
        return "";
    }, [
        activePortfolio === null || activePortfolio === void 0 ? void 0 : activePortfolio.portfolio_info.portfolio_name,
        subAccounts.length
    ]);
    return {
        subAccounts: subAccounts,
        approvedSubAccounts: approvedSubAccounts,
        canCreatePortfolio: canCreatePortfolio,
        subAccountError: subAccountError,
        activeAccountName: activeAccountName,
        getSubAccounts: getSubAccounts
    };
};


/***/ }),

/***/ 74981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSwitchAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3683);
/* harmony import */ var _useSubAccounts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65361);




function useSwitchAction() {
    var setModal = (0,features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(s) {
        return s.openModal;
    });
    var getSubAccounts = (0,_useSubAccounts__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().getSubAccounts;
    var onOpenTransferCash = function() {
        setModal(features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_1__/* .ModalNames.TRANSFER_CASH */ .s.TRANSFER_CASH);
    };
    var onOpenTransferStock = function() {
        setModal(features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_1__/* .ModalNames.TRANSFER_STOCK */ .s.TRANSFER_STOCK);
    };
    var onCreatePortfolio = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var data, canCreatePortfolio;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return getSubAccounts();
                    case 3:
                        data = _ctx.sent;
                        canCreatePortfolio = data.can_create_new_sub_account;
                        if (canCreatePortfolio) {
                            _ctx.next = 8;
                            break;
                        }
                        setModal(features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_1__/* .ModalNames.PORTFOLIO_CREATE_BLOCKED */ .s.PORTFOLIO_CREATE_BLOCKED);
                        return _ctx.abrupt("return");
                    case 8:
                        setModal(features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_1__/* .ModalNames.PORTFOLIO_CREATE */ .s.PORTFOLIO_CREATE);
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        }));
        return function onCreatePortfolio() {
            return _ref.apply(this, arguments);
        };
    }();
    var onOpenTransferSelect = function() {
        setModal(features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_1__/* .ModalNames.TRANSFER_SELECT */ .s.TRANSFER_SELECT);
    };
    return {
        onOpenTransferCash: onOpenTransferCash,
        onOpenTransferStock: onOpenTransferStock,
        onCreatePortfolio: onCreatePortfolio,
        onOpenTransferSelect: onOpenTransferSelect
    };
};


/***/ }),

/***/ 3897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export isElementTypeOf */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var isElementTypeOf = function(target, element) {
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(target) && target.type === element;
};
var Else = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
var If = function(props) {
    var condition = props.condition, children = props.children;
    if (condition) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children).filter(function(child) {
                return !isElementTypeOf(child, Else);
            })
        });
    }
    return react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, function(child) {
        if (isElementTypeOf(child, Else)) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child);
        }
        return null;
    });
};
If.Else = Else;
/* harmony default export */ __webpack_exports__["Z"] = (If);


/***/ }),

/***/ 96909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "go": function() { return /* binding */ SubAccountStatus; }
/* harmony export */ });
/* unused harmony exports SubAccountPurpose, CanotCreateReason */
var SubAccountStatus;
(function(SubAccountStatus) {
    SubAccountStatus["PENDING"] = "ACCOUNT_STATUS_PENDING";
    SubAccountStatus["APPROVED"] = "ACCOUNT_STATUS_APPROVED";
    SubAccountStatus["REJECTED"] = "ACCOUNT_STATUS_REJECTED";
})(SubAccountStatus || (SubAccountStatus = {}));
var SubAccountPurpose;
(function(SubAccountPurpose) {
    SubAccountPurpose["TRADING"] = "PURPOSE_TRADING";
    SubAccountPurpose["LONG_TERM_INVESTING"] = "PURPOSE_LONG_TERM_INVESTING";
    SubAccountPurpose["SHORT_TERM_INVESTING"] = "PURPOSE_SHORT_TERM_INVESTING";
})(SubAccountPurpose || (SubAccountPurpose = {}));
var CanotCreateReason;
(function(CanotCreateReason) {
    CanotCreateReason["INSUFFICIENT"] = "REASON_TYPE_INSUFFICIENT_EQUITY_AMOUNT";
    CanotCreateReason["MAX_REACHED"] = "REASON_TYPE_MAX_SUB_ACCOUNT_REACHED";
})(CanotCreateReason || (CanotCreateReason = {}));


/***/ }),

/***/ 21489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

// eslint-disable-next-line max-len
var useBroadcastChannel = function(channelName) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), channel = ref[0], setChannel = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), message = ref1[0], setMessage = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isChannelOpen = ref2[0], setIsChannelOpen = ref2[1];
    // Initialize the BroadcastChannel when the component mounts
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var newChannel = new BroadcastChannel(channelName);
        setChannel(newChannel);
        setIsChannelOpen(true);
        // Clean up the channel when the component unmounts
        return function() {
            newChannel.close();
            setIsChannelOpen(false);
        };
    }, [
        channelName
    ]);
    // Listen for messages from the channel
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (channel) {
            var handleMessage = function(event) {
                setMessage(event.data);
            };
            channel.onmessage = handleMessage;
            // Clean up event listener when the channel changes
            return function() {
                channel.onmessage = null;
            };
        }
        return undefined;
    }, [
        channel
    ]);
    // Function to post a message to the channel
    var postMessage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(msg) {
        if (channel && isChannelOpen) {
            channel.postMessage(msg);
        }
    }, [
        channel,
        isChannelOpen
    ]);
    return {
        message: message,
        postMessage: postMessage
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useBroadcastChannel);


/***/ })

}]);